import React from 'react';
import { EarlyCheckinIndicator, LateCheckoutIndicator, OwnerBlockIndicator, MaintenanceBlockIndicator } from '../job-indicators';

const ReportJobFlags = ({ isEarlyCheckin, isLateCheckout, isOwnerBlock, isMaintenanceBlock }) => {
  if (!isEarlyCheckin && !isLateCheckout && !isOwnerBlock && !isMaintenanceBlock) {
    return <span className="text-gray-400 text-xs">None</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {isEarlyCheckin && <EarlyCheckinIndicator />}
      {isLateCheckout && <LateCheckoutIndicator />}
      {isOwnerBlock && <OwnerBlockIndicator />}
      {isMaintenanceBlock && <MaintenanceBlockIndicator />}
    </div>
  );
};

export default ReportJobFlags; 